import loadData from '../../../helpers/data-loader'

export default {
  async loadDataAsyn() {
    return Promise.resolve(this.loadData())
  },

  loadData() {
    return loadData("importQuestion")
  },
}
